module.exports = __webpack_public_path__ + "img/notepad5.d8105c58.svg";